import React from 'react'
import {Container,Typography,Button} from '@mui/material'
import {Link as RouterLink} from 'react-router-dom'
import * as ROUTES from '../routes'

/**
 * The old sell page used a public property submission form which is no longer
 * supported by the backend (property management is done via the admin panel).
 * Visitors are directed to the contact page to express interest instead.
 */
export default function SellPropertyScreen(props){

    return(
        <Container
            disableGutters
            maxWidth='md'
            component='div'
            sx={{padding:5, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', minHeight:'60vh'}}
        >
            <Typography variant='h4' textAlign='center' mb={2}>
                Sell or List Your Property
            </Typography>
            <Typography variant='body1' textAlign='center' mb={2} maxWidth={500}>
                Interested in listing your property with us? We would love to hear from you.
                Send us a message through the contact page and one of our agents will be in touch with next steps.
            </Typography>
            <Button
                component={RouterLink}
                to={`/${ROUTES.CONTACT}`}
                variant='contained'
                size='large'
            >
                Contact Us
            </Button>
        </Container>
    )
}
